/* eslint-disable react/prop-types */
import React from "react";
import { Loading } from "orcs-design-system";

/**
 * Loading component for AI chat
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.loading - Whether the operation is still loading
 * @returns {JSX.Element|null} Loading component, if still loading
 */
export const AILoader = ({ loading }) => {
  return loading ? <Loading centered variant="AIchat" /> : null;
};
